import React, { useState, useEffect } from 'react'
import Login from '../components/auth/Login'

import { useSelector, useDispatch } from 'react-redux'
import { toggleLoginForm } from '../actions/appActions'
import { convertErrorYup, errorHandle } from '../utils/helper'
import { login } from '../actions/accountActions'
import { loginFormValid } from '../validation'

const LoginContainer = ({ setShowAccountModal, setShowForgotPassword }) => {
    const dispatch = useDispatch()
    const isOpen = useSelector(state => state.AppReducer.showLoginForm)
    const restaurantInfo = useSelector(state => state.RestaurantReducer)

    const [form, setForm] = useState({})
    const [errors, setErrors] = useState({})

    const closeLoginForm = () => {
        dispatch(toggleLoginForm(false))
    }

    const handleInputChange = e => {
        const { name, value } = e.target
        setForm(prev => ({ ...prev, [name]: value }))
    }

    const clearErrorField = field =>
        setErrors(prev => ({ ...prev, [field]: '' }))

    const handleSubmit = async e => {
        e && e.preventDefault()

        try {
            await loginFormValid.validate(form, { abortEarly: false })
            dispatch(
                login({
                    params: {
                        ...form,
                        grant_type: "password",
                    },
                    onDone: ({ success, responseData }) => {
                        !success && errorHandle(responseData)
                    },
                })
            )
        } catch (error) {
            if (error?.name === 'ValidationError') {
                setErrors(convertErrorYup(error))
            }
        }
    }

    useEffect(() => {
        !isOpen && setForm({})
    }, [isOpen])

    return (
        <Login
            isOpen={isOpen}
            onClose={closeLoginForm}
            form={form}
            errors={errors}
            handleInputChange={handleInputChange}
            clearErrorField={clearErrorField}
            handleSubmit={handleSubmit}
            restaurantInfo={restaurantInfo}
            setShowAccountModal={setShowAccountModal}
            setShowForgotPassword={setShowForgotPassword}
        />
    )
}

export default LoginContainer
